export const TAG_COLORS = ["yellow", "blue", "red", "green", "purple", "orange"] as const;

export const TAG_COLOR_HEX: Record<string, string> = {
  yellow: "#fbbf24",
  blue: "#3b82f6",
  red: "#ef4444",
  green: "#10b981",
  purple: "#8b5cf6",
  orange: "#f97316",
} as const;

export const HTTP_STATUS = {
  OK: 200,
  CREATED: 201,
  NO_CONTENT: 204,
  BAD_REQUEST: 400,
  UNAUTHORIZED: 401,
  FORBIDDEN: 403,
  NOT_FOUND: 404,
  INTERNAL_SERVER_ERROR: 500,
} as const;

export const DATE_FORMATS = {
  TIME: 'HH:mm',
  DATE: 'DD/MM/YYYY',
  DATETIME: 'DD/MM/YYYY HH:mm',
  ISO: 'YYYY-MM-DDTHH:mm:ss.SSSZ',
} as const;

export const FILE_SIZE_LIMITS = {
  IMAGE: 10 * 1024 * 1024, // 10MB
  VIDEO: 100 * 1024 * 1024, // 100MB
  DOCUMENT: 50 * 1024 * 1024, // 50MB
  MAX: 100 * 1024 * 1024, // 100MB
} as const;

export const MIME_TYPES = {
  IMAGE: ['image/jpeg', 'image/png', 'image/gif', 'image/webp'],
  VIDEO: ['video/mp4', 'video/webm', 'video/ogg'],
  DOCUMENT: [
    'application/pdf',
    'application/msword',
    'application/vnd.openxmlformats-officedocument.wordprocessingml.document',
    'application/vnd.ms-excel',
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
  ],
} as const;

export const VALIDATION_PATTERNS = {
  EMAIL: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  PHONE: /^[0-9]{10,11}$/,
  URL: /^https?:\/\/.+/,
} as const;

export const DELAYS = {
  DEBOUNCE_SEARCH: 300,
  DEBOUNCE_INPUT: 500,
  THROTTLE_SCROLL: 100,
  THROTTLE_RESIZE: 200,
} as const;

export const BREAKPOINTS = {
  MOBILE: 768,
  TABLET: 1024,
  DESKTOP: 1280,
} as const;

export const ANIMATION_DURATIONS = {
  FAST: 150,
  NORMAL: 300,
  SLOW: 500,
} as const;

export const PLATFORMS = {
  FACEBOOK: "Facebook",
  ZALO: "Zalo",
  SHOPEE: "Shopee",
} as const;

export const CHANNELS = {
  FACEBOOK: "facebook",
  ZALO: "zalo",
  SHOPEE: "shopee",
} as const;

export const PLATFORM_IDS = {
  FACEBOOK: "facebook",
  ZALO: "zalo",
  SHOPEE: "shopee",
} as const;

